import axios from 'axios';
import iview from 'iview'
import router from '../router'
import { getLocalStorage, setLocalStorage } from '@/utils/tools.js'
// let whiteList = [];
let baseURL = '';
let bootUrl = '';
let path = ''
if (process.env.NODE_ENV === 'development') {
  baseURL = 'https://admin.weimajie.com.cn/';
  bootUrl = 'https://admin.weimajie.com.cn/';
  // baseURL = 'http://39.97.243.63/';
  // bootUrl = 'http://39.97.243.63/';
} else {
  baseURL = 'https://admin.weimajie.com.cn/';
  bootUrl = 'https://admin.weimajie.com.cn/'; //正式ip地址
  // baseURL = 'http://39.97.243.63/';
  // bootUrl = 'http://39.97.243.63/';
}

axios.defaults.baseURL = baseURL;

export {
  baseURL,
  bootUrl
}


// let loading = null;


//开始加载
function startLoading () {
  iview.Spin.show();
}
//结束加载
function endLoading () {
  iview.Spin.hide();
  // loading.close()
}
export function formatData (obj) {
  var arr = [];
  for (var key in obj) {
    arr.push(key + "=" + obj[key]);
  }
  return arr.join("&");
}

//请求拦截
axios.interceptors.request.use(function (config) {
  if (config.url.includes('get_mail_count') === -1) {
    startLoading();
  }
  if (config.url.includes('get_info')) {
    path = config.url
  }
  //console.log(config)  multipart/form-data
  if (config.headers['Content-Type'] === 'application/json') {
    config.headers = {
      "Content-Type": "application/json",
      "Authorization": getLocalStorage('token')
    }
    return config
  }
  if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": getLocalStorage('token')
    }
    return config
  }
  if (typeof config.data !== 'string') {
    config.data = formatData(config.data);
  }
  if (!config.headers.Authorization) {
    config.headers = {
      //x-www-form-urlencoded
      "Content-Type": "application/json",
      "Authorization": getLocalStorage('token')
    }
  }

  return config
});

//响应拦截
axios.interceptors.response.use(res => {
  endLoading()
  if (res.data.code == 4001) {
    iview.Message.error('登录已过期，请重新登录！');
    localStorage.setItem('username', '');
    setLocalStorage('loginState', false);
    localStorage.setItem('token', '');
    localStorage.setItem('routePath', router.app._route.path);
    localStorage.setItem('routePathParams', JSON.stringify(router.app._route.params));
    // alert('登录已过期，请重新登录！');
    /*router.history.push({
      name: 'login',
      path: '/login',
      params: {
        type: 1
      }
    });*/
    setTimeout(() => {
      window.location.href = '/login/1';
    }, 1000)
  }
  if (res.status === 200) {
    return res.data;
  } else {
    // 不为1就是失败
    return Promise.reject(res);
  }
}, res => {
  // 对响应错误做点什么 比如接口不存在等
  endLoading();
  // console.log(res,'-----------')
  if (res.status === 401) { // 没权限
    localStorage.setItem('username', '');
    localStorage.setItem('token', '');
    setLocalStorage('loginState', false);
    localStorage.setItem('routePath', router.app._route.path);
    localStorage.setItem('routePathParams', router.app._route.params);
    /*router.history.push({
      name: 'login',
      params: {
        type: 1
      }
    })*/
    setTimeout(() => {
      window.location.href = '/login/1';
    }, 1000)
  }
  return Promise.reject();
});
export default axios;